<template>
<div class="chapter">
<div class="inner_page">
<h2>Key to Symbols	</h2>
<p> </p>
<p> </p>
<p> </p>
<table border="0" cellpadding="1px" cellspacing="0" class="key" width="100%">
<tbody><tr>
<td class="small" style="padding-top:1px"><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/>   </td>
<td>A great film</td>
</tr>
<tr>
<td class="small" style="padding-top:1px"><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/></td>
<td>A good film</td>
</tr>
<tr>
<td class="small" style="padding-top:1px"><img alt="" src="images/img1.jpg"/><img alt="" src="images/img1.jpg"/></td>
<td>Fair</td>
</tr>
<tr>
<td class="small" style="padding-top:1px"><img alt="" src="images/img1.jpg"/></td>
<td>Poor</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td> </td>
<td><span class="small">G, PG, PG-13, R, NC-17: </span>Ratings of the Motion Picture Association of America</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">G</td>
<td>Indicates that the movie is suitable for general audiences</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">PG</td>
<td>Suitable for general audiences but parental guidance is suggested</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">PG-13</td>
<td>Recommended for viewers <span class="small">13</span> years or above; may contain material inappropriate for younger children</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">R</td>
<td>Recommended for viewers <span class="small">17</span> or older</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top: 2px">NC-17</td>
<td>Intended for adults only</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">141 m.</td>
<td>Running time</td>
</tr>
<tr>
<td> </td>
<td> </td>
</tr>
<tr>
<td class="small" style="padding-top:2px">2010              </td>
<td>Year of theatrical release</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// key.vue?38e5c11c